module.exports = __webpack_public_path__ + "img/ladrillos-laboratorio.d117efae.png";